import "./LawEnforcementPublicSafety.module.css";
import Header from "@/reusable_sections/Header";
import ChemicalIdentification from "./sections/ChemicalIdentification";
import Footer from "@/reusable_sections/Footer";
export default function LawEnforcementPublicSafetyPage() {
  return <div>
      <Header />
      <ChemicalIdentification />
      <Footer />
    </div>;
}